import React, { useEffect, useRef, useState } from "react"
import tw, { styled, css, theme } from "twin.macro"
import { Activities, ActivitiesProps } from "../activity"
import { ReactComponent as ActivityBellSVG } from "../../assets/nav/activity-bell.svg"
import { useClickOutside } from "../../utils/hooks/useClickOutside"
import { useGetActivitiesLazyQuery, useUpdateUserSetLastSeenMutation } from "../../graphql/generated/graphql"
import { useEffectAsync } from "../../utils/hooks/useEffectAsync"
import { NavBarProp } from "."

interface ActivityBellProps {
  hasactivity: string
  isblack?: string
}
const ActivityBell = styled(ActivityBellSVG)(({ hasactivity, isblack }: ActivityBellProps) => [
  tw`hover:(cursor-pointer) w-[28px] h-[28px] tablet-lg:(w-[38px] h-[38px])`,
  css`
    path {
      stroke: ${isblack ? "#ffffff" : "#1C1C1C"};
    }
    &[data-state="ACTIVE"],
    &:hover {
      path {
        stroke: ${theme(`colors.purple`)};
      }
    }
  `,
  hasactivity == "false" &&
    css`
      circle {
        display: none;
      }
    `,
])

export const ActivityIcon = ({ isblack }: NavBarProp) => {
  const [showActivity, setShowActivity] = useState(false)
  const [activities, setActivities] = useState<ActivitiesProps["activities"]>()
  const [getActivities] = useGetActivitiesLazyQuery()
  const [setLastSeen] = useUpdateUserSetLastSeenMutation()
  const ref = useRef(null)
  const hasNewActivity = !!activities && !!activities?.newActivities.length
  useClickOutside(ref, () => setShowActivity(false))

  const fetchActivities = async () => {
    const res = await getActivities()
    if (res.data && res.data.Activities) {
      setActivities(res.data.Activities)
    }
  }
  useEffectAsync(async () => !activities && (await fetchActivities()), [activities])
  useEffectAsync(async () => !showActivity && (await fetchActivities()), [showActivity])
  useEffect(() => {
    return () => setActivities(undefined)
  }, [])

  return (
    <span tw="tablet-lg:(relative ml-auto)" data-testid="activity-icon" ref={ref}>
      <ActivityBell
        isblack={isblack ? `${isblack}` : ""}
        onClick={async () => {
          setShowActivity(!showActivity)
          await setLastSeen()
        }}
        data-testid={`${hasNewActivity ? "red-dot-bell" : "bell"}`}
        data-state={showActivity ? "ACTIVE" : "DEFAULT"}
        hasactivity={`${hasNewActivity}`}
      />
      {showActivity && (
        <div tw="z-10 absolute top-0 right-0 left-0 tablet-lg:(top-16 right-0 left-auto)">
          <Activities {...{ activities, setShowActivity }} />
        </div>
      )}
    </span>
  )
}
